import React, {useEffect, useState} from 'react';
import moment from 'moment';
import {useSelector, useDispatch} from 'react-redux';
import {alertTypes, useAlerts} from '../ui/alert';
import {
  enviarReporteThunk,
  enviarReporteDuck,
  reportesEnviadosGetDuck,
  reportesEnviadosGetThunk,
} from './duck';
import {getDate, responseSelector} from '../utils/utils';
import {ReportesEnviadosListView} from './ReportesEnviadosListView';
import {useQueryParams} from '../utils/useQueryParams';

const queryString = require('query-string');

const tipoOptions = [
  {value: 'todos', label: 'Todos'},
  {value: 'diario', label: 'Diario'},
  {value: 'semanal', label: 'Semanal'},
  {value: 'mensual', label: 'Mensual'},
];

export const ReportesEnviadosList = ({history, token}) => {
  const [isModalShown, setIsModalShown] = useState(false);

  const {queryParams, queryParamsloaded} = useQueryParams(history);

  const dispatch = useDispatch();

  const reportesEnviadosGet = useSelector(state => state.reportesEnviadosGet);
  const enviarReporteModel = useSelector(state => state.enviarReporte);

  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalResults, setTotalResults] = useState(0);
  const [lista, setLista] = useState(null);
  const {submitAlert, setTopAlert, topAlert} = useAlerts();
  const [fechaInicio, setFechaInicio] = useState();
  const [fechaFin, setFechaFin] = useState();
  const [tipoOption, setTipoOption] = useState({
    value: 'todos',
    label: 'Todos',
  });
  const [selectorId, setSelectorId] = useState();
  const [sumatoria, setSumatoria] = useState();

  const _getFiltersFromQueryParams = queryParams => {
    const page = Number(queryParams?.page ?? 1);

    const fechaInicio =
      queryParams?.fechaInicio ??
      moment().startOf('month').format('YYYY-MM-DD');
    const fechaFin =
      queryParams?.fechaFin ?? moment().endOf('month').format('YYYY-MM-DD');
    const tipo = queryParams?.tipo ?? 'todos';
    const selectorId = queryParams?.selectorId ?? 'todos';

    return {
      page,
      fechaInicio,
      fechaFin,
      tipo,
      selectorId,
    };
  };

  const getReportesEnviados = filters => {
    if (!filters) {
      throw new Error('No filters received');
    }

    dispatch(
      reportesEnviadosGetThunk({
        userToken: token.raw,
        limit: pageSize,
        page: filters.page,
        fechaInicio: filters.fechaInicio,
        fechaFin: filters.fechaFin,
        frecuencia: filters.tipo === 'todos' ? null : filters.tipo,
        selectorId: filters.selectorId === 'todos' ? null : filters.selectorId,
      }),
    );
  };

  useEffect(() => {
    if (!queryParamsloaded) return;

    const filters = _getFiltersFromQueryParams(queryParams);

    setPage(filters.page);
    setFechaInicio(moment(filters.fechaInicio).toDate());
    setFechaFin(moment(filters.fechaFin).toDate());
    const mTipoOptionSelected = tipoOptions.find(
      option => option.value === filters.tipo,
    );
    setTipoOption(mTipoOptionSelected ?? tipoOptions[0]);
    setSelectorId(filters.selectorId);

    setFilters(filters);

    getReportesEnviados(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams, queryParamsloaded]);

  useEffect(() => {
    const {data, error, errorMessage} = responseSelector(reportesEnviadosGet);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(reportesEnviadosGetDuck.actions.clear());
    }

    if (data) {
      setTotalResults(data.count);
      setLista(data.items);
      setSumatoria(data.sumatoria);

      dispatch(reportesEnviadosGetDuck.actions.clear());
    }
  }, [reportesEnviadosGet]);

  useEffect(() => {
    const {error, errorMessage, httpStatus} =
      responseSelector(enviarReporteModel);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(enviarReporteDuck.actions.clear());
    }

    if (httpStatus === 200) {
      setIsModalShown(false);

      setTopAlert({
        text: 'Reporte enviado',
        type: alertTypes.success,
      });

      dispatch(enviarReporteDuck.actions.clear());
    }
  }, [enviarReporteModel]);

  const handlePage = page => {
    const strNewParams = queryString.stringify({
      page,
      fechaInicio: getDate(fechaInicio),
      fechaFin: getDate(fechaFin),
      tipo: tipoOption.value,
      selectorId,
    });

    history.replace(`${history.location.pathname}?${strNewParams}`);
  };

  const enviarReporte = () => {
    dispatch(enviarReporteThunk({userToken: token.raw}));
  };

  return (
    <ReportesEnviadosListView
      history={history}
      topAlert={topAlert}
      submitAlert={submitAlert}
      totalResults={totalResults}
      page={page}
      pageSize={pageSize}
      handlePage={handlePage}
      lista={lista}
      reportesEnviadosGet={reportesEnviadosGet}
      fechaInicio={fechaInicio}
      setFechaInicio={setFechaInicio}
      fechaFin={fechaFin}
      setFechaFin={setFechaFin}
      tipoOption={tipoOption}
      setTipoOption={setTipoOption}
      tipoOptions={tipoOptions}
      token={token}
      selectorId={selectorId}
      setSelectorId={setSelectorId}
      sumatoria={sumatoria}
      isModalShown={isModalShown}
      setIsModalShown={setIsModalShown}
      enviarReporte={enviarReporte}
      enviarReporteModel={enviarReporteModel}
    />
  );
};
